module.exports = __webpack_public_path__ + "img/CM-MS-24-Toyota-Modern.0672871f.jpg";